import { isNil } from 'lodash';
import { types as t } from 'mobx-state-tree';

import {
  MainIdeaExplanationStore,
} from '../../../../../question-data-model/Explanation/_implementations/main-idea-explanation.store';
import { AdminReadingExplanationStore } from './admin-reading-explanation.store';

export const AdminDetailOnlyStore = t
  .compose(MainIdeaExplanationStore, AdminReadingExplanationStore)
  .named('AdminDetailOnly')
  .actions((self) => ({
    init(data: any, exp: any) {
      self.detailExplanation = null;
    },
  }))
  .views((self) => ({
    get isCompleted(): boolean {
      return Boolean(self.detailExplanation);
    },
    get isDirty(): boolean {
      return !isNil(self.detailExplanation);
    },
  }));
